import React from "react";
import moment from "moment";
import Check from "../../asset/approve-icon.png";
import Cross from "../../asset/cancel-icon.png";
import "./AccordionApar.css";

const StatusIcon = ({ ok }) => (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <img
      style={{ width: "24px" }}
      src={ok ? Check : Cross}
      alt={ok ? "OK" : "Tidak OK"}
    />
  </div>
);

const rowStyle = (index) => ({
  background: index % 2 === 0 ? "white" : "#f8f9fb",
});

const AccordionApar = ({ data, isOpen, onClick, mock }) => {
  const isIncoming = data.type === "Incoming";
  const isChecksheet = data.type === "checksheet";

  return (
    <div className={`accordion-item ${isOpen ? "is-open" : ""}`}>
      <div className="accordion-title" onClick={onClick}>
        <p className="accordion-no">
          No APAR: <b>{data.noApar}</b>
        </p>

        <span
          className={`accordion-type type-${String(data.type).toLowerCase()}`}
        >
          {data.type}
        </span>

        <p className="accordion-petugas">
          {data.petugas ? data.petugas.split(" ")[0] : ""}
        </p>

        <div className="accordion-toggle">
          {isChecksheet && (
            <span className="accordion-date">
              {moment(data.timestamp)
                .utcOffset("+0700")
                .format("DD-MM-YYYY, HH:mm:ss")}
            </span>
          )}
          {isIncoming && (
            <span className="accordion-date">
              {moment(data.date).utcOffset("+0700").format("DD-MM-YYYY")}
            </span>
          )}
          <span className="accordion-chevron">{isOpen ? "−" : "+"}</span>
        </div>
      </div>

      {isOpen && (
        <div className="accordion-content">
          {isIncoming ? (
            <>
              <p style={{ margin: "0 0 10px" }}>Supplier: {data.supplier}</p>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th className="th-checksheet-apar">No.</th>
                      <th className="th-checksheet-apar">Item Check</th>
                      <th className="th-checksheet-apar">Standar</th>
                      <th
                        className="th-checksheet-apar"
                        style={{ textAlign: "center" }}
                      >
                        Checklist
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.checklist &&
                      data.checklist.map((ele, index) => (
                        <tr key={index} style={rowStyle(index)}>
                          <td className="td-checksheet-apar">{index + 1}.</td>
                          <td
                            className="td-checksheet-apar"
                            style={{ textAlign: "left" }}
                          >
                            {ele.itemCheck}
                          </td>
                          <td
                            className="td-checksheet-apar"
                            style={{ textAlign: "left", fontStyle: "italic" }}
                          >
                            {ele.standar}
                          </td>
                          <td
                            className="td-checksheet-apar"
                            style={{ textAlign: "center" }}
                          >
                            {index === 7 ? (
                              `${ele.beratTabungApar} Kg`
                            ) : index === 8 ? (
                              `${ele.beratIsiApar} Kg`
                            ) : (
                              <StatusIcon ok={ele.isStandard} />
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <p style={{ margin: 0 }}>
              <b>Keterangan: </b>
              {data.keterangan}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default AccordionApar;
